import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { CheckCircle, Shield } from 'lucide-react';

export function VaultComplianceCard() {
  const checks = [
    { label: 'Chiffrement AES-256', passed: true },
    { label: 'Conformité loi El Khomri', passed: true },
    { label: 'Intégrité des documents', passed: true },
    { label: 'Audit trail complet', passed: true },
  ];

  return (
    <Card>
      <CardHeader title="Conformité" />
      <CardContent>
        <div className="space-y-2">
          {checks.map((check) => (
            <div key={check.label} className="flex items-center gap-2">
              {check.passed ? (
                <CheckCircle className="h-4 w-4 text-success-500" />
              ) : (
                <Shield className="h-4 w-4 text-danger-500" />
              )}
              <span className="text-sm text-neutral-700 dark:text-neutral-300">{check.label}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
